import Vue from 'vue';
import i18n from '@/i18n';

import { getUser, getUsers } from '@/services/users';

/**
 * @typedef {Object} User
 * @property {string} label the human-readable identifier of the user
 * @property {string} username the numeric identifier of the user
 * @property {string} first_name the first name of the user
 * @property {string} last_name the last name of the user
 * @property {'operator'|'Bus'|'inspector'} type the type of user
 * @property {boolean} can_access_routing_profiles whether the user can access routing profiles
 * @property {Object} details various details about the user (polymorphic)
 */

export const state = {
  index: {},
};

export const mutations = {
  setUsers(state, users = []) {
    users.forEach(user => {
      delete user.id;
      user.label = computeUserLabel(user);
      Vue.set(state.index, user.username, user);
    });
  },

  setUser(state, user) {
    user.label = computeUserLabel(user);
    Vue.set(state.index, user.username, user);
  },

  removeUser(state, user) {
    Vue.delete(state.index, user.username);
  },
};

function computeUserLabel(user) {
  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`;
  } else if (user.details.vehicle_no) {
    return i18n.t('users.labels.bus', {
      vehicle_no: user.details.vehicle_no,
    });
  } else {
    return user.username;
  }
}

export const actions = {
  getUser({ commit }, username) {
    return getUser(username).then(response => {
      commit('setUser', response.data);
      return response;
    });
  },

  getUsers({ commit }) {
    return getUsers().then(response => {
      commit('setUsers', response.data);
    });
  },
};

export const getters = {
  getUserByUsername: state => username => {
    return state.index[username];
  },
  getUsersByRole: state => role => {
    return Object.values(state.index).filter(user => user.type === role);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
